export default __webpack_public_path__ + "static/writing-feedback@2x-70d098cca5144543ef4279d12c1f0857.png";